import React from 'react';
import { Link } from "react-router-dom";

export const GlassesCategory = () => {
    return (
        <div className="lg:flex flex-row justify-between bg-gray-100 p-6 homeCate space-y-6 lg:space-y-0 md:columns-3 lg:columns-2 columns-3 lg:space-x-4 space-x-0">
            <Link to="/store" className="bg-white rounded-lg p-2 text-center hover:shadow-lg block h-28 md:h-auto">
                <img src="images/e-glass.jpg" alt="Sightkart" />
                <h4 className="text-base mt-1 text-gray-500">Eyeglasses</h4>
            </Link>
            <Link to="/store" className="bg-white w-full md:w-auto rounded-lg p-2 text-center hover:shadow-lg block h-28 md:h-auto">
                <img src="images/s-glass.jpg" alt="Sightkart" />
                <h4 className="text-base mt-1 text-gray-500">Sunglasses</h4>
            </Link>
            <Link to="/store" className="bg-white rounded-lg p-2 text-center hover:shadow-lg block h-28 md:h-auto">
                <img src="images/l-frame.jpg" alt="Sightkart" />
                <h4 className="text-base mt-1 text-gray-500">Air Wrap</h4>
            </Link>
            <Link to="/lens" className="bg-white rounded-lg p-2 text-center hover:shadow-lg block h-28 md:h-auto">
                <img src="images/e-leneses.jpg" alt="Sightkart" />
                <h4 className="text-base mt-1 text-gray-500">Contact Lenses</h4>
            </Link>
            <Link to="/store" className="bg-white rounded-lg p-2 text-center hover:shadow-lg block h-28 md:h-auto">
                <img src="images/clip-glass.jpg" alt="Sightkart" />
                <h4 className="text-base mt-1 text-gray-500">Clip-On Glasses</h4>
            </Link>
            <Link to="/store" className="bg-white rounded-lg p-2 text-center hover:shadow-lg block h-28 md:h-auto">
                <img src="images/p-glass.jpg" alt="Sightkart" />
                <h4 className="text-base mt-1 text-gray-500">Progressive</h4>
            </Link>
        </div>
    )
}
